import React, { useState } from 'react'
import '../AffidavitTemp/affidavit.css'
import Sidebar from '../../../components/Sidebar/Sidebar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight, faFileLines, faRefresh, faSearch } from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom'
import TopBar from '../../../components/topbar'


function CaseDocTemp() {

    const dummyCaseDocs = [
        {
            title: 'CLAIMANTS’LIST OF WITNESS(ES)',
            refNum: 'LSJ/CD066/2023',
            datecreated: 'Mon Oct 30 2023',
            assignedTo: 'Shehu Iginla',
            status: 'Draft',
        },
        {
            title: 'AMENDED STATEMENT OF CLAIM',
            refNum: 'N/A',
            datecreated: 'Mon Oct 30 2023',
            assignedTo: 'Not Assigned',
            status: 'Approved',
        },
        {
            title: 'COUNTER AFFIDAVIT',
            refNum: 'LSJ/CD066/2023',
            datecreated: 'Mon Oct 30 2023',
            assignedTo: 'Shehu Iginla',
            status: 'Ready for Signature',
        },
        {
            title: 'ISSUES FOR DETERMINATION',
            refNum: 'LSJ/CD066/2023',
            datecreated: 'Mon Oct 30 2023',
            assignedTo: 'Shehu Iginla',
            status: 'Submitted',
        },
        {
            title: 'FORM 18',
            refNum: 'LSJ/CD066/2023',
            datecreated: 'Mon Oct 30 2023',
            assignedTo: 'Shehu Iginla',
            status: 'Draft',
        },
        {
            title: 'DEFENDANTS’ AMENDED STATEMENT OF DEFENCE',
            refNum: 'LSJ/CD066/2023',
            datecreated: 'Mon Oct 30 2023',
            assignedTo: 'Shehu Iginla',
            status: 'Ready for Signature',
        },
        {
            title: 'ANSWER',
            refNum: 'N/A',
            datecreated: 'Mon Oct 30 2023',
            assignedTo: 'Not Assigned',
            status: 'Approved',
        },
        {
            title: 'COUNTER AFFIDAVIT AGAINST',
            refNum: 'LSJ/CD066/2023',
            datecreated: 'Mon Oct 30 2023',
            assignedTo: 'Shehu Iginla',
            status: 'Draft',
        },
        {
            title: "DEFENDANT'S JOINT REPLY",
            refNum: 'LSJ/CD066/2023',
            datecreated: 'Mon Oct 30 2023',
            assignedTo: 'Shehu Iginla',
            status: 'Ready for Signature',
        },
        {
            title: 'MEMORANDUM OF ISSUES FOR DETERMINATION',
            refNum: 'LSJ/CD066/2023',
            datecreated: 'Mon Oct 30 2023',
            assignedTo: 'Shehu Iginla',
            status: 'Draft',
        },
        {
            title: 'FURTHER AND BETTER AFFIDAVIT',
            refNum: 'LSJ/CD066/2023',
            datecreated: 'Mon Oct 30 2023',
            assignedTo: 'Shehu Iginla',
            status: 'Ready for Signature',
        },
        {
            title: 'AFFIDAVIT OF URGENCY',
            refNum: 'LSJ/CD066/2023',
            datecreated: 'Mon Oct 30 2023',
            assignedTo: 'Shehu Iginla',
            status: 'Draft',
        },
        {
            title: 'AFFIDAVIT OF NON-SETTLEMENT',
            refNum: 'N/A',
            datecreated: 'Mon Oct 30 2023',
            assignedTo: 'Not Assigned',
            status: 'Approved',
        },
        {
            title: 'DEFENDANTS AMENDED STATEMENT OF DEFENCE',
            refNum: 'LSJ/CD066/2023',
            datecreated: 'Mon Oct 30 2023',
            assignedTo: 'Shehu Iginla',
            status: 'Ready for Signature',
        },
        {
            title: 'AFFIDAVIT OF NON-RESPONSE AND INTENTION TO PROCEED TO CIVIL LITIGATION',
            refNum: 'LSJ/CD066/2023',
            datecreated: 'Mon Oct 30 2023',
            assignedTo: 'Shehu Iginla',
            status: 'Draft',
        },
        {
            title: 'CERTIFICATE OF COMPLIANCE WITH SECTION 84 OF THE EVIDENCE ACT',
            refNum: 'LSJ/CD066/2023',
            datecreated: 'Mon Oct 30 2023',
            assignedTo: 'Shehu Iginla',
            status: 'Ready for Signature',
        },
        {
            title: 'NOTICE OF PRELIMINARY OBJECTION',
            refNum: 'N/A',
            datecreated: 'Mon Oct 30 2023',
            assignedTo: 'Not Assigned',
            status: 'Approved',
        },
        {
            title: 'AMENDED STATEMENT OF CLAIM',
            refNum: 'LSJ/CD066/2023',
            datecreated: 'Mon Oct 30 2023',
            assignedTo: 'Shehu Iginla',
            status: 'Draft',
        },
        {
            title: 'MEMORANDUM OF ISSUES FOR DETERMINATION',
            refNum: 'N/A',
            datecreated: 'Mon Oct 30 2023',
            assignedTo: 'Not Assigned',
            status: 'Approved',
        },
        {
            title: 'AFFIDAVIT OF URGENCY',
            refNum: 'LSJ/CD066/2023',
            datecreated: 'Mon Oct 30 2023',
            assignedTo: 'Shehu Iginla',
            status: 'Ready for Signature',
        },
    ]

    const [openSupport, setOpenSupport] = useState(false)

    const [uploadFileName, setUploadFileName] = useState('Upload Document')
    
    const supportChange = (e) => {
        const file = e.target.files[0]

        setUploadFileName(file.name)
    }

  return (
    <div className='case-doc-temp'>
        <Sidebar />
        <div className="body">
            
            <TopBar status="Home/Affidavit-templates"/>
            <div className="search-table">
                <div className="form-inp">
                    
                    <input type="text" placeholder='Title/Reference Number' id='search-title'/>
                </div>
                <div className="form-inp">
                    <label htmlFor="doc-status">Document Status</label>
                    <select id="doc-status">
                        <option value="" disabled>Filter by Status</option>
                        <option value="all">All</option>
                        <option value="draft">Draft</option>
                        <option value="submitted">Submitted</option>
                        <option value="rework">Rework</option>
                        <option value="ready">Ready for Signature</option>
                        <option value="signed">Signed</option>
                        <option value="approved">Approved</option>
                    </select>
                </div>
                <button className='red'>Search <FontAwesomeIcon icon={faSearch} /></button>
                <div className="reset-fields">
                    <p>Reset Fields</p>
                    <FontAwesomeIcon icon={faRefresh} />
                </div>
            </div>
            <div className="aff-table">
                <div className="all-div">
                    <FontAwesomeIcon icon={faFileLines} />
                    <h3>All Templates</h3>
                </div>
                <div className="table-wrapper">
                    <table>
                        <thead>
                            <tr>
                                <th>Title</th>
                                <th>Reference Number</th>
                                <th>Date Created</th>
                                <th>Assigned To</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                dummyCaseDocs.map((doc, i) => { return (
                                    <tr key={i}>
                                        <td>{doc.title}</td>
                                        <td className='case-refnum'><FontAwesomeIcon icon={faFileLines} />{doc.refNum}</td>
                                        <td>{doc.datecreated}</td>
                                        <td className={ doc.assignedTo === 'Not Assigned' ? 'not-assigned' : ''}>{doc.assignedTo}</td>
                                        <td className={ doc.status === 'Approved' ? 'approve' : doc.status === 'Submitted' ? 'submitted' : doc.status === 'Ready for Signature' ? 'ready' : ''}>{doc.status}</td>
                                        <td className='view-affbtn'>
                                            <Link to='/edm/create-temp/view-temp'><button>View <FontAwesomeIcon icon={faAngleRight} /></button></Link>
                                            <button className='upload-support' onClick={() => setOpenSupport(true)}>Upload Supporting Document</button>
                                        </td>
                                    </tr>
                                )})
                            } 
                        </tbody>
                    </table>
                </div>
            </div>
            <div className={ openSupport ?  "upload-dialog open" : "upload-dialog"}>
                <div className="upload-box">
                    <h3>Upload Supporting Document.</h3>
                    <div className="upload-file-btn">
                        <label htmlFor="upload-input">{uploadFileName}</label>
                        <input
                            type="file"
                            id="upload-input"
                            onChange={supportChange}
                        />
                    </div>  
                    <div className="form-inp">
                        <label htmlFor="select-type">Select Upload Type (Optional)</label>
                        <select id="select-type">
                            <option value="" disabled selected>--Select upload type--</option>
                            <option value="seal">SEAL</option>
                            <option value="stamp">STAMP</option>
                            <option value="passport">PASSPORT</option>
                            <option value="signature">SIGNATURE</option>
                            <option value="exhibit">EXHIBIT</option>
                        </select>
                    </div>
                    <p className="warn">Maximum File Upload: 10MB</p>

                    <button className='red' onClick={() => setOpenSupport(false)}>Cancel</button>
                    <button className="black" onClick={() => setOpenSupport(false)}>Upload</button>
                </div>
            </div>
        </div>
    </div>
  )
}

export default CaseDocTemp